import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render() {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95426 31.0457 0 20 0C8.95426 0 0 8.95426 0 20C0 31.0457 8.95426 40 20 40ZM16.6667 13.3333V20.9648C16.6667 22.4056 17.3452 23.763 18.4981 24.6277L22.4664 27.2221L24.0139 24.7803L20.0555 22.1855C19.6712 21.8974 19.4445 21.4449 19.4445 20.9648V13.3333H16.6667Z",
          "clip-rule": "evenodd",
        }),
      ],
    )
  );
}
